import React from 'react';

export const SidebarThemeContext = React.createContext({
  sidebarTextColor: '',
  sidebarBackgroundColor: '',
  sidebarItemHoverBackground: '',
});
